<template>
  <div class="modal fade" id="modalAddCompany" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="companyToAdd" class="modal-dialog modal-lg">
      <form v-on:submit="submitCompany">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Add Organisation information</h4>
          </div>
          <div class="modal-body">
            <div class="row" style="margin-top: 15px">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="form-group">
                  <label for="cp_name" class="col-sm-3 control-label required text-left">Company Name</label>
                  <div class="col-sm-9">
                    <input type="" v-model="companyToAdd.lastName" id="cp_name" class="form-control" name="lastName" required>
                    <label v-if="errorLastName" class="error">{{ errorLastName }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div v-for="(affiliation, key) in companyToAdd.author_organisations" v-bind:key="key" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
                <div class="form-group">
                  <label for="cp_country" class="col-sm-3 control-label text-left">Country</label>
                  <div class="col-sm-9">
                    <v-select2  id="cp_country" name="cp_country" :aria-autocomplete="true" :options="countries" label="name" v-model="affiliation.organisation.country"
                               :placeholder="'Chose countries'" :searchable="true" :class="{'has-error' : errorCountry, 'has-success' : errorCountry === false}" :dropdownParent="'modalAddCompany'"></v-select2>
                    <label v-if="errorCountry" class="error">{{errorCountry }}</label>
                  </div>
                </div>
              </div>
                <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
                  <div class="form-group">
                    <label for="cp_email" class="col-sm-3 control-label text-left">Contact Email</label>
                    <div class="col-sm-9">
                      <input v-model="affiliation.email" id="cp_email" class="form-control" name="cp_email">
                      <label v-if="errorEmail && errorEmail[key]" class="help-block text-danger" :class="{'has-error' : errorEmail[key] , 'has-success' : errorEmail === false}">{{ errorEmail[key] }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
                  <div class="form-group">
                    <label for="cp_phone" class="col-sm-3 control-label text-left">Contact Phone</label>
                    <div class="col-sm-9">
                      <input v-model="affiliation.organisation.phone" id="cp_phone" class="form-control" name="cp_phone">
                      <label v-if="errorPhone && errorPhone[key]" class="help-block text-danger" :class="{'has-error' : errorPhone[key] , 'has-success' : errorPhone === false}">{{ errorPhone[key] }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
                  <div class="form-group">
                    <label for="cp_website" class="col-sm-3 control-label text-left">Website</label>
                    <div class="col-sm-9">
                      <input v-model="affiliation.organisation.website" id="cp_website" class="form-control" name="cp_website" placeholder="http://www.">
                      <label v-if="errorWebsite && errorWebsite[key]" class="help-block text-danger" :class="{'has-error' : errorWebsite[key] , 'has-success' : errorWebsite === false}">{{ errorWebsite[key] }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12" style="margin-top: 15px">
                  <div class="form-group">
                    <label for="cp_phone" class="col-sm-3 control-label text-left">Description</label>
                    <div class="col-sm-9">
        <textarea v-model="affiliation.organisation.description" id="activity_overview" class="form-control"  minlength="0"  maxlength="3000" placeholder=""
                  rows="3" cols="3" :class="{'has-error' : errorDescription, 'has-success' : errorDescription === false}"></textarea>
                      <span class="help-block m-b-none text-right" v-if="affiliation.organisation.description">{{affiliation.organisation.description.length}} Characters</span>
                      <label v-if="errorDescription" class="error">{{ errorDescription }}</label>
                    </div>
                  </div>
                </div>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" >Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda,
    vSelect2
  },
  props: ['value', 'listSelected'],
  name: 'AddCompany',
  watch: {
    value: function (value) {
      this.companyToAdd = value
    }
  },
  methods: {
    submitCompany: function (e) {
      e.preventDefault()
      this.errorLastName = null
      this.errorEmail = null

      if (this.companyToAdd !== null) {
        this.submit.loading = true
        this.companyToAdd.author_organisations[0].organisation.organisationName = this.companyToAdd.lastName
        this.axios.post('/company/', {
          last_name: this.companyToAdd.lastName,
          author_organisations: this.companyToAdd.author_organisations,
          list_id: this.listSelected.id
        })
          .then((response) => {
            this.submit.loading = false
            this.$eventHub.$emit('updateCompanyAuthorList', true)
            this.companyToAdd = null

            // this.getResources()
            $('#modalAddCompany').modal('hide')
            this.$notify({
              type: 'success',
              title: 'Added !',
              content: 'Company added to your list ' + this.listSelected.title,
              placement: 'bottom-right'
            })
          }).catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorLastName = errors['last_name'][0]
                break
              case 2:
                this.errorEmail = {}
                Object.keys(errors).forEach((error) => {
                  let matches = error.match(/\.(\d)\./)
                  this.errorEmail[matches[1]] = errors[error][0].replace(error, 'email')
                })
                break
            }
            this.submit.loading = false
          })
      }
    },
    addEmail: function (event) {
      event.preventDefault()
      if (this.companyToAdd !== null) {
        this.companyToAdd.author_organisations.push({
          organisation: {
            organisationName: this.companyToAdd.lastName
          },
          country: null,
          email: null
        })
      }
    },
    removeEmail: function (event, index) {
      event.preventDefault()
      if (this.companyToAdd !== null) {
        this.companyToAdd.author_organisations.splice(index, 1)
      }
    },
    getResources: function () {
      this.axios.get('/countries')
        .then((response) => {
          this.countries = response.data
        })
        .catch(function (error) {
        })
    }
  },
  data () {
    return {
      errorLastName: null,
      errorEmail: null,
      errorPhone: null,
      errorWebsite: null,
      errorCountry: null,
      errorDescription: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      companyToAdd: null,
      countries: null
    }
  },
  mounted () {
  },
  beforeMount () {
    this.companyToAdd = this.value
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/AddCompany.vue